// Stamped at build time so we can verify which version is running.
// Imported as a string into NavigationSidebar's footer.
export const BUILD_ID: string =
  // @ts-expect-error injected by Vite via define()
  typeof __BUILD_ID__ !== "undefined" ? (__BUILD_ID__ as string) : "dev";
